<template>
  <div>
    <h3 class="text-c">支付成功</h3>
    <van-icon name="passed" color="#07c160" size="60" />
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

  },
};
</script>

<style scoped lang="less">
.text-c {
  text-align: center;
  margin-top: 40px;
  font-size: 20px;
  padding: 0 20px;
}
</style>
